<template>
  <div id="login">
    <div class="form-wrapper dark-form" v-show="visibleStep === 1">
      <!--<img class="logo" src="../assets/ELAS.TECH.png" alt="">-->
      <a-form :form="form" class="login-form" @submit="handleSubmit">
        <a-alert type="error" :message="errorMessage" banner v-show="errorMessage" />
        <br>
        <a-form-item>
          <a-input
            v-decorator="[
                'email',
                { rules: [
                        { required: true, message: 'Please input your email address!' },
                        { type: 'email', message: 'The input is not valid E-mail!', }
                    ]
                },
            ]"
            placeholder="Email address"
          >
            <a-icon slot="prefix" type="user" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-input
            v-decorator="[
                'password',
                { rules: [{ required: true, message: 'Please input your Password!' }] },
                ]"
            type="password"
            placeholder="Password"
          >
            <a-icon slot="prefix" type="lock" />
          </a-input>
        </a-form-item>
        <a-form-item>
          <a-checkbox
            v-decorator="[
                'remember',
                {
                    valuePropName: 'checked',
                    initialValue: true,
                },
                ]"
          >Remember me</a-checkbox>          
          <a-spin  :spinning="loading">
              <a-button type="primary" html-type="submit" class="login-form-button">
              Log in
            </a-button>
          </a-spin>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      user: null,
      visibleStep: 1,
      loading: false,
      errorMessage: null,
      mfaForm: {
        code: '',
      },
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'normal_login' });
    this.formCode = this.$form.createForm(this, { name: 'verify_code' });
  },
  methods: {
    ...mapMutations({
      setSession: 'Auth/setSession',
      setUsername: 'setUsername',
    }),
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // console.log('Received values of form: ', values);
          this.login(values);
        }
      });
    },

    async login(data) {
      this.loading = true;
      try {
        this.isBtnLoading = true;
        const result = await this.$Amplify.Auth.signIn(
          data.email,
          data.password,
        );

        this.setSession(result.signInUserSession);
        this.setUsername(data.email);
        this.$router.push({ path: '/' });
        this.isBtnLoading = false;
      } catch (error) {
        this.error = error.message;
        // console.log('ERROR', error);
        const isNotConfirmed = error.message === 'User is not confirmed.';
        this.errorMessage = error.message;
        if (isNotConfirmed) {
          this.errorMessage = 'Confirm your email address. We have sent an email with a confirmation link to your email address. In order to complete the sign-up process, please click the confirmation link.';
        }
        this.isBtnLoading = false;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss">
 @import '../../public/scheme';    

#login {
  height: 100%;
  text-align: left;
  .ant-alert {
    margin-bottom: 20px;
    margin-top: 20px;
  }
  .logo {
    width: 256px;
    height: auto;
    margin: 0 auto;
    display: block;
    text-align: center;
    margin-top: 20px;
    margin-bottom: 30px;
  }
  .form-wrapper {
    width: 400px;
    margin: 0 auto;
  }
  .login-form {
    width: 300px;
    margin-top: 83px;
    padding-top: 16px;
    padding-bottom: 16px;
    margin-left: auto;
    margin-right: auto;
  }
  .login-form-button {
    width: 100%;
  }

  .form-wrapper.dark-form {
    background-color: rgba(0, 0, 0, 0.03)!important;
  }
}
</style>
